import { bulk } from './update';
import addError from '../../../utils/error.jsx';

export function request(tag, value) {
    return {
        type: 'TAGS_ADD_VALUE_REQUEST',
        tag,
        value
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'TAGS_ADD_VALUE_ERROR',
        errors
    };
}

export function finish(tag) {
    return (dispatch) => {
        dispatch(bulk([ tag ]));

        dispatch({
            type: 'TAGS_ADD_VALUE_FINISH',
            tag
        });
    };
}

export function clear() {
    return {
        type: 'TAGS_ADD_VALUE_CLEAR'
    };
}
